import { render, staticRenderFns } from "./ProductOptIn.vue?vue&type=template&id=092b6136"
import script from "./ProductOptIn.vue?vue&type=script&lang=js"
export * from "./ProductOptIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports